import React from "react"
import ReactDOM from "react-dom"

import SiteEntryComponent from "./main/siteEntryComponent.jsx"

$(document).ready(function () {
  ReactDOM.render(<SiteEntryComponent />, document.getElementById("content-region"))
})
